import { render, staticRenderFns } from "./sub-factor-excel-filter.vue?vue&type=template&id=17983ab6&scoped=true&"
import script from "./sub-factor-excel-filter.vue?vue&type=script&lang=js&"
export * from "./sub-factor-excel-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17983ab6",
  null
  
)

export default component.exports